var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      staticStyle: {
        "background-color": "#fff",
        overflow: "hidden",
        "padding-bottom": "-10px",
      },
    },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "left-box" },
          [
            _c(
              "draggable",
              {
                staticClass: "list-group",
                attrs: { handle: ".handle" },
                model: {
                  value: _vm.itemList,
                  callback: function ($$v) {
                    _vm.itemList = $$v
                  },
                  expression: "itemList",
                },
              },
              [
                _c(
                  "ul",
                  { staticClass: "ul-unstyled" },
                  _vm._l(_vm.itemList, function (element, index) {
                    return _c(
                      "li",
                      { key: element.id, staticClass: "list-group-item" },
                      [
                        _c("div", { staticClass: "handle" }, [
                          _c("aside", { staticClass: "seq" }, [
                            _vm._v(" " + _vm._s(++index) + " "),
                          ]),
                          _c(
                            "main",
                            { staticClass: "item" },
                            [
                              element.ColumnType === "input"
                                ? _c("Input", {
                                    attrs: { data: element },
                                    on: {
                                      addItem: _vm.addItem,
                                      delItem: _vm.delItem,
                                    },
                                  })
                                : _vm._e(),
                              element.ColumnType === "textarea"
                                ? _c("Textarea", {
                                    attrs: { data: element },
                                    on: {
                                      addItem: _vm.addItem,
                                      delItem: _vm.delItem,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "right-box" }, [
          _c("div", { staticClass: "type-button-group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-info btn-sm",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.add({ type: "單行文字" })
                  },
                },
              },
              [_vm._v(" 單行文字 ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-info btn-sm",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.add({ type: "多行文字" })
                  },
                },
              },
              [_vm._v(" 多行文字 ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-sm",
                staticStyle: { background: "#3dba90", color: "#fff" },
                attrs: { type: "button" },
                on: { click: _vm.viewExample },
              },
              [_vm._v(" 預覽 ")]
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "modal", attrs: { id: "exampleModal", tabindex: "-1" } },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c(
                  "perfect-scrollbar",
                  { staticClass: "modal-body" },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "mb-4",
                        staticStyle: {
                          "margin-left": "25px",
                          color: "#3dba90",
                        },
                      },
                      [_c("strong", [_vm._v("問卷")])]
                    ),
                    _vm._l(_vm.itemList, function (item, index) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "preview-content" },
                        [
                          _c("div", { staticClass: "preview-item" }, [
                            _c("strong", [_vm._v(_vm._s(++index))]),
                          ]),
                          _c("div", { staticClass: "preview-item flex-2" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _c(
                                "h5",
                                { staticStyle: { "margin-top": "5px" } },
                                [
                                  _c("strong", [_vm._v(_vm._s(item.Title))]),
                                  item.require
                                    ? _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#bdbdbd",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.description) + " ")]
                              ),
                            ]),
                            _c("div", [
                              item.type === "input"
                                ? _c("input", {
                                    staticClass: "preview-input",
                                    attrs: { type: "text" },
                                  })
                                : _vm._e(),
                              item.type === "textarea"
                                ? _c("textarea", {
                                    staticClass: "preview-textarea",
                                    attrs: { rows: "5", type: "text" },
                                  })
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    _c("div", { staticClass: "text-center mt-4 mb-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          staticStyle: { padding: "5px 40px" },
                          attrs: { type: "button" },
                        },
                        [_vm._v(" 送出 ")]
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }